import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import "bootstrap/dist/css/bootstrap.min.css"; // Importa el CSS de Bootstrap
import "bootstrap"; // Importa el JavaScript de Bootstrap

createApp(App).use(createPinia()).use(router).mount("#app");
